export default "__VITE_ASSET__f5618362__"